define('views/modules/calendar/animated-session/session-week-panel',[
    // Libs
    'underscore', 'backbone', 'utils',
    // Events
    'services/events/calendar-events',
    // views
    'views/modules/calendar/calendar-item-panel',
    'views/modules/calendar/animated-session/session/session-week-content',
    'views/modules/feedback/feedback',
], function(
    // Libs
    _, Backbone, U,
    // Events
    CalendarEvents,
    // views
    VCalendarItemPanel,
    VSessionWeekContent,
    VFeedback
) {

    var VSessionWeekPanel = VCalendarItemPanel.extend({
        header: {
            title: "calendar:Animated Session",
            subtitle: "calendar:View the session week details",
        },
        tabs: [
            { id: 'details', title: 'Details', icon: 'sl-icon-eye', active: true, callback: 'showDetails' },
            { id: 'feedback', title: 'calendar:Feedback', icon: 'sl-icon-bubbles', callback: 'showFeedback' },
        ],
        content: {
            details: VSessionWeekContent,
            feedback: VFeedback,
        },

        defaultView: 'details',

        initialize: function() {
            _.extend(this, {
                session: this.options.session
            });

            this.listenTo(CalendarEvents, { 'session:destroy': this.onSessionDestroy })
                .listenTo(this.session, { 'sync': this.onSessionSync });
        },

        getContentViewOptions: function(opt) {
            return _.extend({
                model: this.model,
            }, _.pick(this.options, [
                'session',
                'profile',
                'group',
                'url',
                'role',
                'conversationId'
            ]), opt);
        },

        ////////////
        // events //
        ////////////
        onSessionDestroy: function(id) {
            if (this.model.is(id)) this.close();
        },
        onItemDestroy: function(id) {
            if (this.model.is(id)) this.close();
        },

        onSessionSync: function(model) {
            this.view.layout.setTitle(model.getName());
        },

    });

    return VSessionWeekPanel;
});

